module.exports = __webpack_public_path__ + "img/icon-ln.4aaafc5a.svg";